import { render, staticRenderFns } from "./DashboardTemplate.vue?vue&type=template&id=38f3bfbc&scoped=true&"
import script from "./DashboardTemplate.vue?vue&type=script&lang=js&"
export * from "./DashboardTemplate.vue?vue&type=script&lang=js&"
import style0 from "./DashboardTemplate.vue?vue&type=style&index=0&id=38f3bfbc&prod&lang=sass&scoped=true&"
import style1 from "./DashboardTemplate.vue?vue&type=style&index=1&id=38f3bfbc&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f3bfbc",
  null
  
)

export default component.exports